module.exports = __webpack_public_path__ + "static/headshot-mike-myers-3x.2a53534c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-mike-myers-3x.jpg
// module id = 130
// module chunks = 35783957827783 152909308826437